export default __webpack_public_path__ + "static/media/32.06fd6fe3.jpeg";